import React from 'react';
import { Spin, Empty, Card, Table } from 'antd';

interface RankRangeTabProps {
  rankRangeData: any;
  loading: boolean;
}

/**
 * 搜索频率区间分析Tab组件
 * 展示区间市场类型分布透视表和区间统计摘要
 */
export const RankRangeTab: React.FC<RankRangeTabProps> = ({
  rankRangeData,
  loading,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" tip="正在加载区间分析数据...">
          <div style={{ minHeight: 100 }} />
        </Spin>
      </div>
    );
  }

  if (!rankRangeData) {
    return <Empty description="暂无区间分析数据" />;
  }

  // 动态生成区间分布表格的列
  const rangeDistributionColumns = [
    {
      title: '搜索频率区间',
      dataIndex: 'rank_range',
      key: 'rank_range',
      fixed: 'left' as const,
      width: 150,
    },
    ...(rankRangeData.range_analysis[0] ? 
      Object.keys(rankRangeData.range_analysis[0])
        .filter(k => k !== 'rank_range' && k !== '总计')
        .map((marketType: string) => ({
          title: marketType,
          dataIndex: marketType,
          key: marketType,
          width: 120,
        }))
      : []
    ),
    {
      title: '总计',
      dataIndex: '总计',
      key: 'total',
      width: 100,
      render: (val: number) => <strong>{val}</strong>,
    },
  ];

  return (
    <div style={{ padding: '20px 0' }}>
      <Card title="区间市场类型分布" style={{ marginBottom: 24 }}>
        <Table
          dataSource={rankRangeData.range_analysis}
          rowKey="rank_range"
          pagination={false}
          scroll={{ x: 1000 }}
          columns={rangeDistributionColumns}
        />
      </Card>

      <Card title="区间统计摘要">
        <Table
          dataSource={rankRangeData.range_summary}
          rowKey="rank_range"
          pagination={false}
          columns={[
            {
              title: '搜索频率区间',
              dataIndex: 'rank_range',
              key: 'rank_range',
              width: 150,
            },
            {
              title: '关键词数量',
              dataIndex: 'keyword_count',
              key: 'keyword_count',
              width: 120,
              sorter: (a: any, b: any) => a.keyword_count - b.keyword_count,
            },
            {
              title: '平均搜索频率排名',
              dataIndex: 'avg_search_rank',
              key: 'avg_search_rank',
              width: 160,
              render: (val: number) => val !== undefined && val !== null ? val.toFixed(1) : '-',
            },
            {
              title: '平均市场机会指数',
              dataIndex: 'avg_opportunity',
              key: 'avg_opportunity',
              width: 160,
              render: (val: number) => val !== undefined && val !== null ? val.toFixed(4) : '-',
            },
            {
              title: '平均市场稳定指数',
              dataIndex: 'avg_stability',
              key: 'avg_stability',
              width: 160,
              render: (val: number) => val !== undefined && val !== null ? val.toFixed(4) : '-',
            },
            {
              title: '总搜索量估算',
              dataIndex: 'total_search_volume',
              key: 'total_search_volume',
              width: 140,
              render: (val: number) => val !== undefined && val !== null ? val.toLocaleString() : '-',
            },
          ]}
        />
      </Card>
    </div>
  );
};

